var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"0","cy":"0","r":_vm.radius,"stroke-width":_vm.strokeWidth,"stroke":_vm.strokeColor,"stroke-dasharray":_vm.perimeter,"stroke-dashoffset":_vm.strokeDashoffset,"transform":`rotate(${_vm.rotateAngle})`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }